export const INGREDIENT_PRICES = {
  "bread-salad": 30,
  "bread-cheese": 40,
  "bread-meat": 60,
};

export const LABELS = {
  "bread-meat": "Meat",
  "bread-salad": "Salad",
  "bread-cheese": "Cheese",
};
